<template>
  <b-modal ref="modal" title="Urlop" v-model="showModal" @hidden="$emit('cancel')" ok-title="Zapisz" cancel-title="Anuluj" @ok.prevent="submit">
    <b-form @submit.stop.prevent="dates.reason = textarea; $emit('submit', $schema);">
      <div v-if="!id && !userId">
        <b-form-group label="Pracownik" :state="isUserValid" invalid-feedback="Wybierz pracownika" v-if="$is('admin', 'hr', 'manager')">
          <v-select v-model="selectedUser" label="text" :options="users" />
        </b-form-group>
      </div>

      <div class="row">
        <div class="col-md-6">
          <app-datepicker class="dateInput" :model="$schema.dateStart"/>
        </div>

        <div class="col-md-6">
          <app-datepicker class="dateInput" :model="$schema.dateEnd" />
        </div>

        <div class="col-md-12" v-if="showAllDay">
          <app-checkbox :model="$schema.allDay" />
        </div>

        <div class="col-md-12" v-if="!$schema.$model.allDay">
          <div class="row">
            <div class="col-md-6">
              <app-select :model="$schema.hourStart" :values="hours" />
            </div>

            <div class="col-md-6">
              <app-select :model="$schema.minuteStart" :values="minutes" />
            </div>
            <div class="col-md-6">
              <app-select :model="$schema.hourEnd" :values="hours" />
            </div>
            
            <div class="col-md-6">
              <app-select :model="$schema.minuteEnd" :values="minutes" />
            </div>
          </div>
        </div>

        <b-form-group class="col-md-12 mt-2" label="Powód">
          <app-textarea class="reason" :model="$schema.reason" />
        </b-form-group>

        <div class="col-md-12">
          <b-form-group label="Rodzaj nieobecności" :state="isAbsenceValid" invalid-feedback="Wybierz rodzaj nieobecności">
            <v-select v-model="selectedAbsence" label="text" :options="absences" />
          </b-form-group>
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import moment from 'moment';

import formMixin from '@/mixins/formMixin';
import { generateNumberArray, toClock } from '@/utils';
import { UserResource } from '@/resources/user.resource';
import { AbsenceResource } from '@/resources/absence.resource';
import schema from '@/schemas/dayOff.schema';

export default {
  mixins: [formMixin],
  schema,
  props: {
    dates: Object,
    show: Boolean,
    event: Object,
    userId: { type: Number, required: false }
  },
  beforeMount() {
    this.getUsers();
    this.getAbsences();
    this.prepareSchema();
    this.showModal = this.show;
  },
  data() {
    return {
      showModal: false,
      textarea: '',
      users: [],
      absences: [],
      selectedAbsence: null,
      selectedUser: null,
      hours: generateNumberArray(20, 1, 6).map(value => ({ value, text: toClock(value) })),
      minutes: generateNumberArray(50, 10, 0).map(value => ({ value, text: toClock(value) })),
      id: null
    };
  },
  methods: {
    prepareSchema() {
      if (this.event) {
        this.$set(this, 'id', this.event.id);
        this.$schema.$setData({
          dateStart: moment(this.event.items[0].date).format('YYYY-MM-DD'),
          dateEnd: moment(this.event.items[this.event.items.length - 1].date).format('YYYY-MM-DD'),
          reason: this.event.reason,
          hourStart: this.event.hourStart,
          hourEnd: this.event.hourEnd,
          minuteStart: this.event.minuteStart,
          minuteEnd: this.event.minuteEnd,
          allDay: !this.event.hourStart
        });
      } else {
        this.$schema.dateStart.$model = moment(this.dates.dateStart).format('YYYY-MM-DD');
        this.$schema.dateEnd.$model = moment(this.dates.dateEnd).format('YYYY-MM-DD');
      }
    },
    async getUsers() {
      const users = await UserResource.list();
      this.$set(this, 'users', users.map(user => ({ value: user.id, text: user.firstName + ' ' + user.lastName })));
    },
    async getAbsences() {
      const absences = await AbsenceResource.list();
      this.$set(this, 'absences', absences.map(item => ({ value: item.id, text: item.name })));
      if (this.event) {
        this.$set(this, 'selectedAbsence', this.absences.find(absence => absence.value === this.event.absenceId));
      }
    },
    submit() {
      const validationResult = this.$schema.$validateAll();
      if (validationResult.length || !this.isUserValid || !this.isAbsenceValid) {
        return;
      }
      const userId = this.userId || (this.selectedUser && this.selectedUser.value);
      const absenceId = this.selectedAbsence && this.selectedAbsence.value;
      this.$emit('submit', this.$schema, userId, absenceId, this.id);
      this.$refs.modal.hide();
    }
  },
  computed: {
    showAllDay() {
      const start = moment(this.$schema.dateStart.$model);
      const end = moment(this.$schema.dateEnd.$model);
      if (start && end) {
        return start.startOf('day').isSame(end.startOf('day'));
      }
      return false;
    },
    isUserValid() {
      return !!this.id || !!this.userId || !this.$isAdmin() || !!this.selectedUser;
    },
    isAbsenceValid() {
      return !!this.selectedAbsence;
    }
  }
};
</script>
<style>
.reason textarea,
.reason label,
.dateInput input {
  display: block;
  width: 100%;
}
.reason textarea {
  min-height: 3rem;
}
.dateInput input {
  height: calc(2.25rem + 2px);
  padding: 0.375rem 0.75rem;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

label.select {
  display: block;
}
</style>
